import type { InputPuzzle } from "./puzzle.types";

export const LAYMAN_PUZZLES: InputPuzzle[] = [
  {
    p: "000098675400006200000020100030201456640000718507000002008042960360009020290057003",
    s: "123498675485716239976523184839271456642935718517864392758342961364189527291657843",
    d: -12605,
  },
  {
    p: "100000600000080023658230000539000840842653000700840005297010004405000380006400719",
    s: "123794658974586123658231497539172846842653971761849235297318564415967382386425719",
    d: -13181,
  },
  {
    p: "120080000098000000060312085870003000342609018009278000700500324930020007254000809",
    s: "123985476598467231467312985875143692342659718619278543781596324936824157254731869",
    d: -12357,
  },
  {
    p: "125000900047000000630004100003682051206045000500013270350470019900501040400000735",
    s: "125367984847129563639854127793682451216745398584913276352476819978531642461298735",
    d: -12357,
  },
  {
    p: "125007800000100040003960000607209500082571004400600012030700029204800370701304080",
    s: "125437896976158243843962157617249538382571964459683712538716429264895371791324685",
    d: -12357,
  },
  {
    p: "100408900908067124060009035800005602006083070700000381500006498302904706090801253",
    s: "125438967938567124467219835813795642246183579759642381571326498382954716694871253",
    d: -12578,
  },
  {
    p: "000800070060000043004000012039205000548760001602300005403097128206080054800050307",
    s: "125834679967521843384976512739215486548769231612348795453697128276183954891452367",
    d: -12605,
  },
  {
    p: "120300490040000107000600000905016080004003210010970000007060043069408000080730920",
    s: "126357498543892167798641352935216784674583219812974635257169843369428571481735926",
    d: -12641,
  },
  {
    p: "120005000000103628300270041900042003070350100030807204000920400009060832402038015",
    s: "126485379547193628398276541981642753274359186635817294853921467719564832462738915",
    d: -12936,
  },
  {
    p: "020400307045270000900000840600791084098300706704056093301000408000020130009100005",
    s: "126489357845273961973615842632791584598342716714856293351967428467528139289134675",
    d: -12605,
  },
  {
    p: "006570830007143690943600571600801005008205000000467000401300000890000006365918247",
    s: "126579834587143692943682571634891725718235469259467183471326958892754316365918247",
    d: -12953,
  },
  {
    p: "120400096069050704003906012030002045615390070700500369090120407000809621080000900",
    s: "127483596869251734453976812938762145615394278742518369396125487574839621281647953",
    d: -13277,
  },
  {
    p: "007064803009000006500001002800035204372080100940017030003070401001000065600053000",
    s: "127564893439728516568391742816935274372486159945217638253679481791842365684153927",
    d: -12475,
  },
  {
    p: "000054039400961700600300084249030801000000906070400000054608310080040007061725490",
    s: "127854639438961725695372184249536871513287946876419253754698312982143567361725498",
    d: -12357,
  },
  {
    p: "028490700603027894704000106300700500080935401000000903012009308807204609000010247",
    s: "128496735653127894794583126349761582286935471571842963412679358837254619965318247",
    d: -13277,
  },
  {
    p: "108037600070800500040910080030080020065792801982061470094673000006148007000200360",
    s: "128537649679824513543916782731485926465792831982361475294673158356148297817259364",
    d: -13277,
  },
  {
    p: "100500930600190005050000680080400000740601508300000020090800403070246050461350872",
    s: "128564937637198245954723681589472316742631598316985724295817463873246159461359872",
    d: -12605,
  },
  {
    p: "120500386005100270740000950250060730007800600038750090076480103002076000004200067",
    s: "129547386865193274743628951251964738497832615638751492976485123512376849384219567",
    d: -12936,
  },
  {
    p: "000576000705430600003090701200000830608003470350004210942010060000265943536947020",
    s: "129576384785431692463892751214759836698123475357684219942318567871265943536947128",
    d: -12953,
  },
  {
    p: "009700580800016700760280003000870640040062879607400302495030260070500430300624000",
    s: "129743586853916724764285193932871645541362879687459312495137268276598431318624957",
    d: -13277,
  },
  {
    p: "030450000000209010400071203963100800204000100718300900000700090371590648509618327",
    s: "132456789687239415495871263963125874254987136718364952826743591371592648549618327",
    d: -13277,
  },
  {
    p: "132060040986075002040000069001852600859106200600000000007500036400007050518093020",
    s: "132968745986475312745321869371852694859146273624739581297584136463217958518693427",
    d: -12357,
  },
  {
    p: "134006072000000360600347590420053080016074903003600045001400230200938607060000409",
    s: "134596872957281364682347591429153786516874923873629145791465238245938617368712459",
    d: -13277,
  },
  {
    p: "030000080000130406060049305503096020800000591700081603392008104000004738008005900",
    s: "134657289985132476267849315513496827846273591729581643392768154651924738478315962",
    d: -12605,
  },
  {
    p: "134080096850400031970000004310040279025100300097020160703005080049038000080004003",
    s: "134782596852469731976351824318546279625197348497823165763915482549238617281674953",
    d: -12936,
  },
  {
    p: "000624000648590020900000506010060832384700600006903704063070400021006070000041208",
    s: "135624987648597123972138546719465832384712695256983714863279451421856379597341268",
    d: -12357,
  },
  {
    p: "000048206406120750020063084600050038050290047000836010001005029007302001060914870",
    s: "135748296486129753729563184612457938358291647974836512841675329597382461263914875",
    d: -13277,
  },
  {
    p: "005800002796512408080006001000720000000001006903685000450100309821953764369274815",
    s: "135847692796512438284396571648729153572431986913685247457168329821953764369274815",
    d: -12813,
  },
  {
    p: "105890462406032870027004035009100020000900080000003100900301007300080209761250348",
    s: "135897462496532871827614935649178523213965784578423196982341657354786219761259348",
    d: -12654,
  },
  {
    p: "100000947900070382200930650569003008000680594708529163491002000005301400000040810",
    s: "136258947954176382287934651569413278312687594748529163491862735875391426623745819",
    d: -12953,
  },
  {
    p: "000259000000003905705004000510006790362507014479000002001002049043061070987300020",
    s: "136259487824713965795684231518426793362597814479138652651872349243961578987345126",
    d: -12357,
  },
  {
    p: "136275849809614023000903500690051380084009050000000000361090074045006008000047635",
    s: "136275849859614723472983561697451382284739156513862497361598274745326918928147635",
    d: -12578,
  },
  {
    p: "136009748040780201000010695971342000003007009008691000005204317000108050014905000",
    s: "136529748549786231782413695971342586463857129258691473895264317627138954314975862",
    d: -12329,
  },
  {
    p: "000450209000100300000032017083500970470200001501000800305020146846915030710346598",
    s: "137458269624179385958632417283561974479283651561794823395827146846915732712346598",
    d: -12953,
  },
  {
    p: "037006295580012040200350008006103080010000039008940076800030060670000354400500820",
    s: "137486295589712643264359718946173582715628439328945176851234967672891354493567821",
    d: -13181,
  },
  {
    p: "000000000069025410040001080603000051700100002091050064020580073378912645415736290",
    s: "137498526869325417542671389683247951754169832291853764926584173378912645415736298",
    d: -12953,
  },
  {
    p: "007960204008310600060008307870001460003604008600703000080030540240806009390400876",
    s: "137965284428317695569248317872591463913624758654783921786139542245876139391452876",
    d: -12936,
  },
  {
    p: "000000020950021086002008143760510030200030619010060000000000091500207368396180400",
    s: "138476925954321786672958143769512834285734619413869257827643591541297368396185472",
    d: -12605,
  },
  {
    p: "130092007524700009976380001050000700482900065090501830800153070705200003213000500",
    s: "138492657524716389976385421351864792482937165697521834849153276765248913213679548",
    d: -12329,
  },
  {
    p: "038070640090006017700013985013600790670000150009700036900108400080460500540092860",
    s: "138579642295846317764213985813625794672934158459781236926158473381467529547392861",
    d: -13277,
  },
  {
    p: "038006000700004098409050000084091006002605874650082000003200610201000980576010240",
    s: "138976452765124398429358761384791526912635874657482139893247615241563987576819243",
    d: -13181,
  },
  {
    p: "109405070080160000642089130000650000200090060070801003091076350500908000803510002",
    s: "139425876785163249642789135314652987258397461976841523491276358527938614863514792",
    d: -12605,
  },
  {
    p: "142090005600500910005821040390070008800030609000068000710689253539702000008000197",
    s: "142396785683547912975821346396175428851234679427968531714689253539712864268453197",
    d: -12654,
  },
  {
    p: "142070690896001000030940182000007026268000079004090308980003204621800930403020060",
    s: "142578693896231745735946182319487526268315479574692318987163254621854937453729861",
    d: -12953,
  },
  {
    p: "042639005300071600069208403034000000001000347000500100403015869596080000010062030",
    s: "142639785385471692769258413634127958251896347978543126423715869596384271817962534",
    d: -12357,
  },
  {
    p: "140600090000009074006300125010538900860000500305900487030000850650192700400800216",
    s: "142675398583219674976384125714538962869427531325961487231746859658192743497853216",
    d: -12936,
  },
  {
    p: "002003500300821000869457130517948000638700490000006007906304000081000750000085649",
    s: "142693578375821964869457132517948326638712495294536817956374281481269753723185649",
    d: -13277,
  },
  {
    p: "142050986795008000608290007053470001064305070200009000086520000300940068510830020",
    s: "142753986795168243638294157853472691964315872271689435486527319327941568519836724",
    d: -13277,
  },
  {
    p: "002000703000731920073842560500603409469010358380059216005004032700320890030000000",
    s: "142965783658731924973842561521683479469217358387459216895174632714326895236598147",
    d: -12578,
  },
  {
    p: "143809027609000800000047003007000000350000402021000789500100076832096041706435298",
    s: "143859627679312854285647913967284135358971462421563789594128376832796541716435298",
    d: -13277,
  },
  {
    p: "000802070000100000590000032000014569000720018409580003060438201080005340350271896",
    s: "143892675726153984598647132872314569635729418419586723967438251281965347354271896",
    d: -12936,
  },
  {
    p: "000060820900007501500038000050001702010090008380002914600023400205470006090500270",
    s: "143965827968247531527138649459381762712694358386752914671823495235479186894516273",
    d: -13007,
  },
  {
    p: "040967200920008010876512934650803029000000860010000005539106072400725603000300000",
    s: "143967258925438716876512934657843129394251867218679345539186472481725693762394581",
    d: -13277,
  },
  {
    p: "040260039000090605900500002010076954003800167670005020421703890059681200006400001",
    s: "145268739237194685968537412812376954593842167674915328421753896759681243386429571",
    d: -13277,
  },
  {
    p: "005370982269050700070009504532608007006412805481507296800005000024080050000001028",
    s: "145376982269854713378129564532698147796412835481537296813265479924783651657941328",
    d: -12578,
  },
  {
    p: "145000060206100830807059100400500380000392041070000502010930008083200009900710200",
    s: "145823967296147835837659124429571386658392741371486592512934678783265419964718253",
    d: -12605,
  },
  {
    p: "046070000307000001592613847000082650053094002000060734918020400005040000064931508",
    s: "146278395387459261592613847471382659653794182829165734918526473235847916764931528",
    d: -13277,
  },
  {
    p: "040300700938720615257619438300901506760503941519246003895130200070000100001000000",
    s: "146358792938724615257619438384971526762583941519246873895137264473862159621495387",
    d: -13026,
  },
  {
    p: "140000270070054319500207048000068024080400107024730000007000802802003400491806000",
    s: "146389275278654319539217648713568924685492137924731586367145892852973461491826753",
    d: -12357,
  },
  {
    p: "047205983032800500065000000018072059350001020270590010020730008604000237783906000",
    s: "147265983932847561865319472418672359359481726276593814521734698694158237783926145",
    d: -13277,
  },
  {
    p: "000352006563070004209041700400086007670023100000004685001008000000030970004207508",
    s: "147352896563879214289641753495186327678523149312794685751968432826435971934217568",
    d: -12820,
  },
  {
    p: "000300600086100957029607000804000091001578463000409270008040320000802006402036009",
    s: "147395682386124957529687134874263591291578463635419278768941325913852746452736819",
    d: -13181,
  },
  {
    p: "100009076302000081960801300410002000080000050006038097027496813894013765631080000",
    s: "148329576372645981965871324419752638783964152256138497527496813894213765631587249",
    d: -12953,
  },
  {
    p: "048759020300100748006430000080046200000005801967080403090000500800003900403507000",
    s: "148759326359162748726438195581346279234975861967281453692814537875623914413597682",
    d: -13007,
  },
  {
    p: "040000670060070300003600081006029010085006240291483756932045167614297508057000000",
    s: "148932675569178324723654981476529813385716249291483756932845167614297538857361492",
    d: -12813,
  },
  {
    p: "100205000860073002070008040083006071691300520007140300000032700000694213000701009",
    s: "149265837865473192372918645483526971691387524527149368914832756758694213236751489",
    d: -12605,
  },
  {
    p: "149008200500021849702009001651200984004000705007000120013090650000475012275100000",
    s: "149658273536721849782349561651237984824916735397584126413892657968475312275163498",
    d: -12329,
  },
  {
    p: "040672003800010200602398000000043601000900027420780539004030000061459378783006905",
    s: "149672853837514296652398714975243681318965427426781539594837162261459378783126945",
    d: -12953,
  },
  {
    p: "000703058008006000003000740000800000804057039590402100482500900935274016600090400",
    s: "149723658758146392263985741327819564814657239596432187482561973935274816671398425",
    d: -12820,
  },
  {
    p: "140728000278003000600100728800405900731002500095830062080000050000206007000950806",
    s: "149728635278563419653149728862415973731692584495837162986374251514286397327951846",
    d: -12605,
  },
  {
    p: "100000309400200006076009400061300940800500030207004801685097213004035760000020000",
    s: "152746389498253176376819425561382947849571632237964851685497213924135768713628594",
    d: -12820,
  },
  {
    p: "050476289000132070042985361027018690000600000001090850890004012305021946214769530",
    s: "153476289968132475742985361427518693589643127631297854896354712375821946214769538",
    d: -13202,
  },
  {
    p: "104009307380040000670308109005804903917205060000000725030090600001000004096700001",
    s: "154629387389147256672358149265874913917235468843916725538491672721563894496782531",
    d: -12820,
  },
  {
    p: "154670328020480710078203000300008002080000563465027001700800040800002907090730180",
    s: "154679328623485719978213654319568472287941563465327891731896245846152937592734186",
    d: -13277,
  },
  {
    p: "150020700072003090609507402790142836001000040400005017000701624207000051510290300",
    s: "154829763872463195639517482795142836321678549468935217983751624247386951516294378",
    d: -13277,
  },
  {
    p: "050079004070620100000580763045000671910000300603147020004735002500968000730400000",
    s: "156379284378624195492581763245893671917256348683147529864735912521968437739412856",
    d: -12357,
  },
  {
    p: "100492730940086010302000094205000009000241000400065287501700000624009001038614925",
    s: "156492738947386512382157694265873149879241356413965287591728463624539871738614925",
    d: -12953,
  },
  {
    p: "050030420309100000802005600000004210701903040204500098093210804000009153010306070",
    s: "156738429349162785872495631935684217781923546264571398593217864627849153418356972",
    d: -12605,
  },
  {
    p: "150002004300810000280346500605901307730050009910030008597400006060170005420508000",
    s: "156792834374815962289346571645981327738254619912637458597423186863179245421568793",
    d: -12936,
  },
  {
    p: "000089300084560090003047205002094031000830006308002400926300000801476052070000610",
    s: "157289364284563197693147285562794831749831526318652479926315748831476952475928613",
    d: -12357,
  },
  {
    p: "050200060004050210906304875200501080809006501501020437600002700710090602030065000",
    s: "157289364384657219926314875243571986879436521561928437698142753715893642432765198",
    d: -12936,
  },
  {
    p: "057030028900710000032005000601500090045920000020040305096307102004150009810004570",
    s: "157439628968712453432865917681573294345928761729641385596387142274156839813294576",
    d: -12605,
  },
  {
    p: "150920000800006700004051028000032400000160802030870059090000306008000574073005090",
    s: "157928643829346715364751928981532467745169832236874159592417386618293574473685291",
    d: -13168,
  },
  {
    p: "100000470307004008024758391700839050436500789905070030009305047003680005570000800",
    s: "158293476397164528624758391712839654436521789985476132869315247243687915571942863",
    d: -12953,
  },
  {
    p: "100030042040102590060004030571426983684009201900800450000043000030000814002018005",
    s: "158937642347162598269584137571426983684359271923871456815643729736295814492718365",
    d: -12654,
  },
  {
    p: "150240006308100504060059200890502040500671809070890600032010460985426010000080000",
    s: "159248376328167594467359281896532147543671829271894635732915468985426713614783952",
    d: -13277,
  },
  {
    p: "159004728004050096720981300070416080082000600600800035060000509008065040007109863",
    s: "159634728834257196726981354375416982482593671691872435263748519918365247547129863",
    d: -13277,
  },
  {
    p: "150043020027580003008200059082007500714000000060408001301000690290134785005090312",
    s: "159643827427589163638271459982317546714965238563428971371852694296134785845796312",
    d: -12329,
  },
  {
    p: "109600003040932105007008600000001968800749032903860417312407850090006301000500000",
    s: "159674283648932175237158694574321968861749532923865417312497856795286341486513729",
    d: -12329,
  },
  {
    p: "100003570008200300930704000000480057051360040470900800504130000607000138319678425",
    s: "162893574748256391935714286293481657851367942476925813584132769627549138319678425",
    d: -12329,
  },
  {
    p: "163090084000360001004008600020800000050030472000700069387602905002579308005483726",
    s: "163297584578364291294158637729846153856931472431725869387612945642579318915483726",
    d: -13277,
  },
  {
    p: "004207385830000792207583041080705060700010053501308209300600408058400910000800036",
    s: "164297385835146792297583641983725164726914853541368279379651428658432917412879536",
    d: -12578,
  },
  {
    p: "160007503730801004000000900050000040091376020073005006007020000925030010000169752",
    s: "164297583739851264582643971856912347491376825273485196617528439925734618348169752",
    d: -13007,
  },
  {
    p: "000090005527040900983001000492865731008032600316009800840006570001007004005084190",
    s: "164798325527643918983521467492865731758132649316479852849216573631957284275384196",
    d: -13277,
  },
  {
    p: "060893050895002600000005840009060300053908060080530702007480020000206400400079010",
    s: "164893257895742631372615849249167385753928164681534792537481926918256473426379518",
    d: -12820,
  },
  {
    p: "060230980070090530839050072000421659000060000000583000703846010612005090040000300",
    s: "165237984274198536839654172387421659451769823926583741793846215612375498548912367",
    d: -12605,
  },
  {
    p: "065700200732009100409020600601805903340090020000030700006500001890017300510008400",
    s: "165784239732659184489321657621875943347196528958432716276543891894217365513968472",
    d: -12820,
  },
  {
    p: "000704003900000180370921546690008350000009862203615409001097630006042795709000014",
    s: "165784923942356187378921546694278351517439862283615479421597638836142795759863214",
    d: -13250,
  },
  {
    p: "167294800008000061230080940489610372003429086002000090751008009094000000306070008",
    s: "167294835948753261235186947489615372573429186612837594751348629894562713326971458",
    d: -12329,
  },
  {
    p: "160302008289000003034079010052007040693000000070590032000720385020003900008906004",
    s: "167342598289165473534879216852637149693214857471598632946721385725483961318956724",
    d: -12605,
  },
  {
    p: "107038002945276800238005074009000000021580000080040007014009020792800530356021000",
    s: "167438952945276813238195674479613285621587349583942167814359726792864531356721498",
    d: -12654,
  },
  {
    p: "000290037940008620057640891035100206010560300000000150580426713621057048070000000",
    s: "168295437943718625257643891435179286812564379796832154589426713621357948374981562",
    d: -12953,
  },
  {
    p: "169230000003100050758090020071300080302000006805620704030000860207560390000080047",
    s: "169235478423178659758496123671349582342857916895621734934712865287564391516983247",
    d: -12605,
  },
  {
    p: "169730500230806000000104300000001090600080400080073000893020045521308967476915200",
    s: "169732584234856719758194326347561892615289473982473651893627145521348967476915238",
    d: -12329,
  },
  {
    p: "000005824005602000420180600380570060000200180651000030503900700706008002000400390",
    s: "169735824835642971427189653382571469974263185651894237543926718796318542218457396",
    d: -12475,
  },
  {
    p: "170430000093006702000280003084320017007641000300708000001003850430050976700064200",
    s: "172439568893516742645287193984325617527641389316798425261973854438152976759864231",
    d: -12357,
  },
  {
    p: "170549860050006209009281745700308000890062000000075100527003486013004927004600000",
    s: "172549863458736219369281745741398652895162374236475198527913486613854927984627531",
    d: -12953,
  },
  {
    p: "072050060064010000000470031407000693005300072000020058043792006000640020280100049",
    s: "172853964364219587958476231427581693895364172631927458543792816719648325286135749",
    d: -12820,
  },
  {
    p: "173459062048613059965007304300592480504060231020004605009076103000040000080000000",
    s: "173459862248613759965287314316592487594768231827134695459876123632941578781325946",
    d: -12578,
  },
  {
    p: "103000089900100000504003007700600052650201870238450016090000430007800090412395060",
    s: "173542689926178543584963127741689352659231874238457916895726431367814295412395768",
    d: -12936,
  },
  {
    p: "103548000002397418400000375000950600054270000900030702035400167090703000207615800",
    s: "173548296562397418489162375728951643354276981916834752835429167691783524247615839",
    d: -13277,
  },
  {
    p: "170986520462503008000020673200460731000800402500702009000009300348007200007008000",
    s: "173986524462573918895124673289465731736891452514732869651249387348617295927358146",
    d: -12357,
  },
  {
    p: "170203090200000350000900004810000040000530000003400870050096231962341785731825469",
    s: "174253698296184357385967124819672543647538912523419876458796231962341785731825469",
    d: -12953,
  },
  {
    p: "000083962000497100983126547509014086061030090000609210012305809008902650705861020",
    s: "174583962256497138983126547529714386461238795837659214612345879348972651795861423",
    d: -12430,
  },
  {
    p: "100863905200000006096004010000036090603090058049002673020005060400619780060300040",
    s: "174863925258971436396254817782536194613497258549182673821745369435619782967328541",
    d: -12605,
  },
  {
    p: "100906500008513007005240900030000109619000700007100080051890403090030871480671095",
    s: "174986532928513647365247918832764159619358724547129386751892463296435871483671295",
    d: -12654,
  },
  {
    p: "075083906060074500429000837601407003730020400004000070507090328080700000010842795",
    s: "175283946863974512429561837691457283738629451254318679547196328982735164316842795",
    d: -13277,
  },
  {
    p: "176480359580309100030517802800600405043805900610004080400000008050000001361278594",
    s: "176482359582369147934517862829631475743825916615794283497153628258946731361278594",
    d: -13250,
  },
  {
    p: "070400083005780090008056014723060000081200300650003001810600970460020000037000042",
    s: "176492583345781296298356714723168459981245367654973821812634975469527138537819642",
    d: -12820,
  },
  {
    p: "176000000080700001400096080000060700960470003310800240004010690030905102000002430",
    s: "176538924589724361423196587845263719962471853317859246254317698638945172791682435",
    d: -12641,
  },
  {
    p: "070008092000607500800009671200060905400020060507100003301000006004086010009451700",
    s: "176548392932617584845239671218763945493825167567194823381972456754386219629451738",
    d: -13168,
  },
  {
    p: "000580004300007058548290063009002001803010506700350809460005087200100000085030600",
    s: "176583294392647158548291763659872431823419576714356829461925387237168945985734612",
    d: -12605,
  },
  {
    p: "070940000400000085300070910783010009000009048954083167816500493549000071007001056",
    s: "178945632492136785365872914783614529621759348954283167816527493549368271237491856",
    d: -12329,
  },
  {
    p: "079304800050678000600021503030010905810003607596040308000060781760002000481000200",
    s: "179354862352678194648921573237816945814593627596247318923465781765182439481739256",
    d: -12936,
  },
  {
    p: "170032480560009120030140790000600008026780519050003002245000000001408207080000000",
    s: "179532486564879123832146795917625348326784519458913672245397861691458237783261954",
    d: -12820,
  },
  {
    p: "100638542800050309005000001708304295050200600926715008060090084097800100580076920",
    s: "179638542842157369635942871718364295354289617926715438263591784497823156581476923",
    d: -12578,
  },
  {
    p: "109605803003190067000200041704061302005830600200700080800000700060009000001480030",
    s: "179645823423198567658273941784961352915832674236754189842316795367529418591487236",
    d: -12475,
  },
  {
    p: "100034602603205070002010003000089060000042590096157038000963485930508706568400009",
    s: "179834652643295871852716943725389164381642597496157238217963485934528716568471329",
    d: -12578,
  },
  {
    p: "100500070906270058405000000003690087768034500001057006007003000650900031009060004",
    s: "182549673936271458475386219543692187768134592291857346827413965654928731319765824",
    d: -13007,
  },
  {
    p: "002596034395247008467010090020104000714300000000928000231080046000630907970400300",
    s: "182596734395247168467813295829174653714365829653928471231789546548632917976451382",
    d: -13277,
  },
  {
    p: "100000300030815006050342918820967435073000600090000827907004003215600740000179000",
    s: "182796354439815276756342918821967435573428691694531827967254183215683749348179562",
    d: -13277,
  },
  {
    p: "180976500079100800064283070095012360738504192601009058846000005953020000200000000",
    s: "182976543379145826564283971495812367738564192621739458846397215953621784217458639",
    d: -12578,
  },
  {
    p: "100642500000000200926017000042159070715308004008200601070420030034790102060001000",
    s: "183642597457983216926517483642159378715368924398274651571426839834795162269831745",
    d: -12357,
  },
  {
    p: "183050700907130208050097000300060080079285003608400000700000590890526070500700801",
    s: "183652749967134258254897136325961487479285613618473925746318592891526374532749861",
    d: -13181,
  },
  {
    p: "084000700360170208092045600058001000070594820039780165000020384040308070000000010",
    s: "184263759365179248792845631258631497671594823439782165517926384946318572823457916",
    d: -13181,
  },
  {
    p: "180020075759381046326070000042810590590002867803060021410006000207100000900000018",
    s: "184629375759381246326574189642817593591432867873965421418756932237198654965243718",
    d: -12953,
  },
  {
    p: "085000460630040192000010500090450270000923000002006000253160709401079350879534020",
    s: "185392467637845192924617583398451276746923815512786934253168749461279358879534621",
    d: -13277,
  },
  {
    p: "180000095300510042000000100050890406609247001408650000702000618063072050015400307",
    s: "186324795397516842524789163251893476639247581478651239742935618863172954915468327",
    d: -12936,
  },
  {
    p: "100305000370000605520067001001704800067000543490080012640003000005008200730020906",
    s: "186395427379142685524867391251734869867219543493586712642953178915678234738421956",
    d: -12820,
  },
  {
    p: "100729000975300120430605009760000501043050000000047000001470600390508017027901054",
    s: "186729435975384126432615789768293541243156978519847362851472693394568217627931854",
    d: -12936,
  },
  {
    p: "086000045024003196900061007010700002807200031250090700591304020008002000040010000",
    s: "186927345724583196935461287419736852867245931253198764591374628378652419642819573",
    d: -13007,
  },
  {
    p: "006900502045027000907085401070008300010090705030000009003250140090876250852413967",
    s: "186934572345127896927685431279568314614392785538741629763259148491876253852413967",
    d: -12953,
  },
  {
    p: "000002064090860037463070852530100000000600000940320076058200600009480005614759283",
    s: "187532964295864137463971852536197428872645391941328576758213649329486715614759283",
    d: -13277,
  },
  {
    p: "009000235320100000006203080003000007040562900090407020700054369000609152065021804",
    s: "189746235324185796576293481253918647847562913691437528712854369438679152965321874",
    d: -12357,
  },
  {
    p: "192760804500120900000090100023549716040000295600270348000008431000010600008600579",
    s: "192763854587124963364895127823549716741386295659271348276958431935417682418632579",
    d: -13277,
  },
  {
    p: "093407506007608200080090070200350001036000054010900028005800007040560800820000640",
    s: "193427586457638219682195473278354961936281754514976328365842197741569832829713645",
    d: -13007,
  },
  {
    p: "193006080065020370207053000609004108010600054040000900006319207020807600030065010",
    s: "193476582465928371287153496679534128318692754542781963856319247921847635734265819",
    d: -13181,
  },
  {
    p: "190002570080007923627035018000401097954308261001206040070100050009500702006020000",
    s: "193842576485617923627935418268451397954378261731296845372189654819564732546723189",
    d: -13277,
  },
  {
    p: "193000000207004068486709000800000570900001402674500000309410857540087003700090120",
    s: "193862745257134968486759231812943576935671482674528319329416857541287693768395124",
    d: -12936,
  },
  {
    p: "190320076500001008002050341065070000008010005000000024831007400759030602020105807",
    s: "194328576573641298682759341965472183248913765317586924831267459759834612426195837",
    d: -12605,
  },
  {
    p: "100000003503001000726340015000602174907480632002713008600034000070026540040157090",
    s: "194568723583271469726349815835692174917485632462713958651934287379826541248157396",
    d: -13277,
  },
  {
    p: "095040080362589704840302069006891472001000000289050130000008000604003000008065391",
    s: "195647283362589714847312569536891472471236958289754136953128647614973825728465391",
    d: -13277,
  },
  {
    p: "190040200030985040004062390072030514500074030000050002020790160300026879000018423",
    s: "196347258237985641854162397672839514581274936943651782428793165315426879769518423",
    d: -12329,
  },
  {
    p: "006702580800500947740030126019000402627401830400000601061004095304195268900620000",
    s: "196742583832516947745938126519863472627451839483279651261384795374195268958627314",
    d: -12813,
  },
  {
    p: "097830006304900000060000953500396147009400000003078000700009010900654700280000600",
    s: "197835426354962871862147953528396147679421538413578269746289315931654782285713694",
    d: -12475,
  },
  {
    p: "108032074230800091400090320020400800973600005000209000640387002300160007001920030",
    s: "198532674237846591465791328526473819973618245814259763649387152352164987781925436",
    d: -13181,
  },
  {
    p: "198620000503000006027003010300180900806000345070000168260004097009061284000009601",
    s: "198627453543918726627453819354186972816792345972345168261834597739561284485279631",
    d: -13181,
  },
  {
    p: "000607000300200000020098017030080742740500081809070060203000176971863524654721839",
    s: "198647253367215498425398617536189742742536981819472365283954176971863524654721839",
    d: -12813,
  },
  {
    p: "108070452300005008000090703025016389600800047840037216000080605080004901916050034",
    s: "198673452367245198254198763725416389631829547849537216473981625582364971916752834",
    d: -12953,
  },
  {
    p: "213500009009120008008790000071086205000902060090005807400009183030000920086031704",
    s: "213568479769124538548793612371486295854972361692315847427659183135847926986231754",
    d: -13181,
  },
  {
    p: "213604980090830040070109306057968014480312060162745839548000670000403000000000000",
    s: "213654987695837142874129356357968214489312765162745839548291673726483591931576428",
    d: -13250,
  },
  {
    p: "213690075400125006900037082000000041501200007040050009800502603350004218129060054",
    s: "213698475487125936965437182792386541531249867648751329874512693356974218129863754",
    d: -12953,
  },
  {
    p: "213908700850100003090034120532401690179200800400300050040000006001800470028640509",
    s: "213968745854127963697534128532481697179256834486379251945712386361895472728643519",
    d: -12329,
  },
  {
    p: "214080700653409200900010000800097104700000026046532070409800500300704900020960480",
    s: "214386795653479218978215643832697154795148326146532879469821537381754962527963481",
    d: -12936,
  },
  {
    p: "210700086090030012300102050000200549020600170140075608806091000030067001050308060",
    s: "214759386795836412368142957687213549529684173143975628876491235432567891951328764",
    d: -12357,
  },
  {
    p: "200068530050104020000020060003600217109002043460071980800000070007016002691287354",
    s: "214768539956134728738925461583649217179852643462371985825493176347516892691287354",
    d: -13277,
  },
  {
    p: "016049038080000402407208156009002504172850963534090201058601047701000000000000000",
    s: "216549738385167492497238156869312574172854963534796281958621347741983625623475819",
    d: -12329,
  },
  {
    p: "210784930050090628080000700570009801091070003038241009029000380007000402840030100",
    s: "216784935754193628983526714572369841491875263638241579129457386367918452845632197",
    d: -12936,
  },
  {
    p: "206030047003600000805417060030106070162080403079300601020001800350200000987540126",
    s: "216835947743692518895417362438156279162789453579324681624971835351268794987543126",
    d: -13277,
  },
  {
    p: "000604309368925400405713000000000008049870006082041790006130080704060900830059600",
    s: "217684359368925471495713862173596248549872136682341795926137584754268913831459627",
    d: -12654,
  },
  {
    p: "000680093500000000086109500000003910100200050030571284300057148000020000948300720",
    s: "217685493593742861486139572825463917174298356639571284362957148751824639948316725",
    d: -13007,
  },
  {
    p: "207030009458000160960500000000407000040100907000963025870204300000370280130089050",
    s: "217836549458792163963541872329457618546128937781963425875214396694375281132689754",
    d: -12820,
  },
  {
    p: "010045307007090060096000008024580003000701900070934002702409035109000826053200070",
    s: "218645397437892561596173248924586713365721984871934652782469135149357826653218479",
    d: -12357,
  },
  {
    p: "019385704356740982700002531000869305023570806568100009035016090002900003000000058",
    s: "219385764356741982784692531147869325923574816568123479835416297672958143491237658",
    d: -12813,
  },
  {
    p: "000430800040000061036817429321609700960080100000020600003200948102300070604005003",
    s: "219436857847592361536817429321659784965784132478123695753261948192348576684975213",
    d: -13181,
  },
  {
    p: "019078040300294100406003002000730508502860037700059621024086053060327010030040000",
    s: "219678345358294176476513982641732598592861437783459621124986753965327814837145269",
    d: -12953,
  },
  {
    p: "230457096005029104000816502300080907080000315012970640128705469679000000000000001",
    s: "231457896865329174794816532346581927987264315512973648128735469679148253453692781",
    d: -12953,
  },
  {
    p: "200005060040010792900624105750006000609431000000250000010089050400000087067003900",
    s: "231975864546318792978624135754896213629431578183257649312789456495162387867543921",
    d: -12475,
  },
  {
    p: "005160490000483005100900600851702309726310050040650072007001026000500001510070903",
    s: "235167498679483215184925637851742369726319854943658172497831526362594781518276943",
    d: -12654,
  },
  {
    p: "230194086049278050708365940304020560060000070870040029006017000050402000080050290",
    s: "235194786649278153718365942394721568562839471871546329426917835953482617187653294",
    d: -13277,
  },
  {
    p: "200071800600035400070800502341790658956008701720500000000000105512000300063157294",
    s: "235471869689235417174869532341792658956348721728516943497623185512984376863157294",
    d: -12953,
  },
  {
    p: "200670801670900350089053000002706005000090008096302170408109700927835000060427080",
    s: "235674891674918352189253647812746935743591268596382174458169723927835416361427589",
    d: -13277,
  },
  {
    p: "206100807805726430001098200603010020709800040100400765300000000500070600968200004",
    s: "236145897895726431471398256643517928759862143182439765327684519514973682968251374",
    d: -12605,
  },
  {
    p: "236415809890306205754289016145930620680750491907041083062097000000000700470003000",
    s: "236415879891376245754289316145938627683752491927641583562897134319524768478163952",
    d: -13202,
  },
  {
    p: "036010804080320651000080000623851007040973120000462080068040905100090302490035768",
    s: "236519874789324651514786239623851497845973126971462583368247915157698342492135768",
    d: -13250,
  },
  {
    p: "230504000080300400704082600005800000072049081049205063527430198413908076000000004",
    s: "236594817981367425754182639165873942372649581849215763527436198413958276698721354",
    d: -13277,
  },
  {
    p: "037080500804600007650030802300846170100000408000001005010290053072400901900010006",
    s: "237189564894652317651734892325846179169375428748921635416298753572463981983517246",
    d: -12820,
  },
  {
    p: "037006040065000200940000365300087456480635002076249801620071504800060907009000000",
    s: "237856149165394278948712365392187456481635792576249831623971584814563927759428613",
    d: -12329,
  },
  {
    p: "000010485100070293000204176052600340070392560380145729800700000000009030740800012",
    s: "237916485164578293598234176952687341471392568386145729823761954615429837749853612",
    d: -12329,
  },
  {
    p: "230069574079034206450802910000056040000000300720003060810027095947080001560490000",
    s: "238169574179534286456872913381256749694718352725943168813627495947385621562491837",
    d: -13277,
  },
  {
    p: "030497006490016000076083940002135080861700400753000029304600290019002000520948301",
    s: "238497516495216738176583942942135687861729453753864129384671295619352874527948361",
    d: -13250,
  },
  {
    p: "000004910564900000000020048000581300050200097480079650300060102021000409840000005",
    s: "238754916564918273917623548679581324153246897482379651395467182721835469846192735",
    d: -12475,
  },
  {
    p: "009408600546093210000205340063520481104680053708301906081002500070000000300100800",
    s: "239418675546793218817265349963527481124689753758341926681972534475836192392154867",
    d: -12329,
  },
  {
    p: "000004070500200603607019004090700348402806905350941760000090500065100400924685030",
    s: "239564871541278693687319254196752348472836915358941762813497526765123489924685137",
    d: -13277,
  },
  {
    p: "009000074801200000007309008403000091908000600062190003120406709784921005396785412",
    s: "239658174851274936647319258473862591918543627562197843125436789784921365396785412",
    d: -12578,
  },
  {
    p: "000750004615080200080092350020075000006208090953461728897010042362007010541000000",
    s: "239756184615384279784192356128975463476238591953461728897513642362847915541629837",
    d: -12953,
  },
  {
    p: "239010005700925300008006900000600037970080620460203508090067800000050009304090270",
    s: "239814765746925381518736942825649137973581624461273598192467853687352419354198276",
    d: -12605,
  },
  {
    p: "200000560806020070705693000690105430070060008004702106050070600067940305900056001",
    s: "239817564816524973745693812692185437371469258584732196453271689167948325928356741",
    d: -13181,
  },
  {
    p: "241380000907000483508400001610705802850200736372006004006000345085603009093020010",
    s: "241389567967152483538467921614735892859241736372896154126978345485613279793524618",
    d: -12578,
  },
  {
    p: "040078000900600205600002010500700023800240600023850000000005078012309004458060300",
    s: "241578936937614285685932417564791823879243651123856749396425178712389564458167392",
    d: -12475,
  },
  {
    p: "241006937007900400069400100795000810324810060608307040470008092006005070000000601",
    s: "241586937837921456569473128795642813324819765618357249473168592186295374952734681",
    d: -12936,
  },
  {
    p: "240590000039020840800400020594316200000000301000002004000000080357841692486239517",
    s: "241598736639127845875463129594316278728954361163782954912675483357841692486239517",
    d: -13277,
  },
  {
    p: "001736058003100000975200010020307001006402073030860400700684100360000700410973002",
    s: "241736958683195247975248316824357691596412873137869425752684139369521784418973562",
    d: -12936,
  },
  {
    p: "040000950306090041058000702000087090830004510400050086020908175080010620105702400",
    s: "241876953376295841958431762562187394839624517417359286623948175784513629195762438",
    d: -13181,
  },
  {
    p: "241908030805270914697000800480069000050723081703005000374091600000647190100000000",
    s: "241958736835276914697314852482169375956723481713485269374591628528647193169832547",
    d: -13277,
  },
  {
    p: "200100896900006300008029154702048030009231607400670028800502403020800700050760080",
    s: "243157896915486372678329154762948531589231647431675928897512463326894715154763289",
    d: -13277,
  },
  {
    p: "043176009601090047795003602406709083002041096900032400000004008137068004064000000",
    s: "243176859681295347795483612416759283372841596958632471529314768137568924864927135",
    d: -12329,
  },
  {
    p: "200978001506001080010504000604302007092680000307400012400120005020746108701890040",
    s: "243978561576231489819564723654312897192687354387459612468123975925746138731895246",
    d: -12654,
  },
  {
    p: "200810930736240008801005420054908001607401059010057084160080700008000100000073865",
    s: "245816937736249518891735426354968271687421359912357684163584792578692143429173865",
    d: -12953,
  },
  {
    p: "205803700000012085087405023378124509000070300002300074503207006001540207000000958",
    s: "245863791639712485187495623378124569456978312912356874593287146861549237724631958",
    d: -12329,
  },
  {
    p: "040970361100060004060214587000602079000187036876039100034896205501040090000000000",
    s: "245978361187365924369214587413652879952187436876439152734896215521743698698521743",
    d: -13277,
  },
  {
    p: "200385907590004086180926345032048760010060539760139800000070490000000600000092158",
    s: "246385917593714286187926345932548761418267539765139824651873492829451673374692158",
    d: -13250,
  },
  {
    p: "000010006501086400006400010095000630802507001014060800020054793459270168603108004",
    s: "247319586531786429986425317795841632862537941314962875128654793459273168673198254",
    d: -12329,
  },
  {
    p: "000059610100047580050316204080002406901005730364978100000600007500080300600000042",
    s: "247859613136247589859316274785132496921465738364978125418623957592784361673591842",
    d: -12357,
  },
  {
    p: "240901806009250301100708094670090140590642700002817905086529400910080000000000000",
    s: "247931856869254371153768294678395142591642738432817965786529413915483627324176589",
    d: -12329,
  },
  {
    p: "040053008000070900690020054401008529830090071900147000714605003000034017060710005",
    s: "247953168158476932693821754471368529836592471925147386714685293589234617362719845",
    d: -12936,
  },
  {
    p: "200091300003607580750043210427900600060405927039060040070006100002100403100000000",
    s: "248591376913627584756843219427918635861435927539762841374256198682179453195384762",
    d: -12605,
  },
  {
    p: "208600570793851026516002900032570009085000007001036080320069054009025000000000002",
    s: "248693571793851426516742938632578149985214367471936285327169854869425713154387692",
    d: -12936,
  },
  {
    p: "040719065095608174007005800100006530070451090056237401402003006500002003031004008",
    s: "248719365395628174617345829124896537873451692956237481482573916569182743731964258",
    d: -12953,
  },
  {
    p: "000070305705206008030409000000705986090300701500890200302600519080507040604013802",
    s: "249178365715236498836459127123745986498362751567891234372684519981527643654913872",
    d: -12936,
  },
  {
    p: "249000600170290000000060042730001006580649700690780050920006004067930100800475000",
    s: "249358617176294538358167942734521896581649723692783451925816374467932185813475269",
    d: -13181,
  },
  {
    p: "001408006093520741000010520602080300007060000005039060064052109020000654500607083",
    s: "251478936893526741476913528642185397937264815185739462364852179728391654519647283",
    d: -12357,
  },
  {
    p: "200040730094007001060010050680901347410070609000400105700390512030120076000065493",
    s: "251649738894537261367812954682951347415273689973486125746398512539124876128765493",
    d: -12329,
  },
  {
    p: "251040007000520610396017500460072350127054080035100004610705003783400100040000000",
    s: "251649837874523619396817542468972351127354986935168274612785493783496125549231768",
    d: -13277,
  },
  {
    p: "200176009060002300900300100710800004009530200020401000630058491571294680894603005",
    s: "253176849168942357947385162716829534489537216325461978632758491571294683894613725",
    d: -12953,
  },
  {
    p: "200460000941007530607001290860002910002930608300610072500006000030100807720000065",
    s: "253469781941287536687351294864572913172934658395618472518726349436195827729843165",
    d: -12357,
  },
  {
    p: "050001840060784050070300910007400605600270183030605004090003200014826009300007400",
    s: "253961847961784352478352916127438695645279183839615724596143278714826539382597461",
    d: -12357,
  },
  {
    p: "254070309908302104103900057016209570000805000805637900030090005400063800000001736",
    s: "254176389978352164163984257316249578792815643845637912631798425427563891589421736",
    d: -13277,
  },
  {
    p: "250100003706283450108645070075436000600800045302000860920060510001000030003900724",
    s: "254179683796283451138645279875436192619827345342591867927364518481752936563918724",
    d: -12329,
  },
  {
    p: "254670009360509040709104365000200900007090000040350080090812430000006508420700100",
    s: "254673819361589742789124365835261974617498253942357681596812437173946528428735196",
    d: -12357,
  },
  {
    p: "254700600793065008001340500015000060600500010000610850039152080008400325000807401",
    s: "254781639793265148861349572315978264687524913942613857439152786178496325526837491",
    d: -12936,
  },
  {
    p: "000870910300002487800900506082600701046720305700491008513209670000007150020150000",
    s: "254876913369512487871943526982635741146728395735491268513289674498367152627154839",
    d: -13277,
  },
  {
    p: "254000600600008100908072540003500000005120009109807350800210735301065908002000401",
    s: "254931687637458192918672543783596214465123879129847356896214735341765928572389461",
    d: -12936,
  },
  {
    p: "000030876806000002100682004000093657597000083000750020602019740003070208705268091",
    s: "254931876836547912179682534421893657597126483368754129682319745913475268745268391",
    d: -12329,
  },
  {
    p: "250140000010920060930086001193058700672009835080002000347090080000034000009760450",
    s: "256147398718923564934586271193658742672419835485372619347295186561834927829761453",
    d: -12936,
  },
  {
    p: "006780010301062008409130762130007080094308001007001005760024150010973020940510830",
    s: "256789413371462598489135762135247986694358271827691345763824159518973624942516837",
    d: -13250,
  },
  {
    p: "006819734081670000000350108673005080010038576048006019000241003000503640800000201",
    s: "256819734381674925497352168673195482912438576548726319765241893129583647834967251",
    d: -13277,
  },
  {
    p: "207403908010609740600085200900067500501340600840000027032070490000200000760004802",
    s: "257413968318629745694785231923867514571342689846951327132578496485296173769134852",
    d: -13181,
  },
  {
    p: "257006400004052000309000502030148290908305010042679803680203740423507108000000000",
    s: "257936481814752936369481572536148297978325614142679853685213749423597168791864325",
    d: -12953,
  },
  {
    p: "250109740713864000406700030500010800029587400061093072902048605005070304600000000",
    s: "258139746713864259496725138547612893329587461861493572972348615185976324634251987",
    d: -13277,
  },
  {
    p: "208307940000014020006008000309002085500893700080000293804009512792100630005206409",
    s: "258367941973514826416928357349672185521893764687451293864739512792145638135286479",
    d: -13277,
  },
  {
    p: "000000041970531600106280005300900050500600097400000006702309080895010763600005010",
    s: "258796341974531628136284975367948152581623497429157836712369584895412763643875219",
    d: -12820,
  },
  {
    p: "009030070378004506016085090001507239705023000000841005102000607680002053004000820",
    s: "259136478378294516416785392841567239765923184923841765192358647687412953534679821",
    d: -12936,
  },
  {
    p: "050307400000020500800006297527000940001085700680700100102004370048239651395670000",
    s: "259317486476928513813546297527163948931485762684792135162854379748239651395671824",
    d: -12329,
  },
  {
    p: "259040076100000402470200930800072000000400021610503700300627598000800007786900014",
    s: "259348176163759482478261935894172653537496821612583749341627598925814367786935214",
    d: -12936,
  },
  {
    p: "200097540903050207000286000052400030319605700004000605705061090020009051090000070",
    s: "261397548983154267547286913652478139319625784874913625735861492426739851198542376",
    d: -12820,
  },
  {
    p: "200457030907030041040912600120003000470008050308000060000370510000024387734185920",
    s: "261457839957836241843912675125763498476298153398541762682379514519624387734185926",
    d: -13277,
  },
  {
    p: "261480395307260814984510200023708900700305480548690732405036028830100000002050000",
    s: "261487395357269814984513267623748951719325486548691732475936128836172549192854673",
    d: -13202,
  },
  {
    p: "060004000000219067095806012000102900920000170074000000002900748030007001640501329",
    s: "261754893483219567795836412356172984928345176174698235512963748839427651647581329",
    d: -12820,
  },
  {
    p: "001700003890630002500090001080000024003025176600047000429503610100060037070100290",
    s: "261758943894631752537492861785916324943825176612347589429573618158269437376184295",
    d: -12605,
  },
  {
    p: "001840735708000249040003008180650000420300090603072184090008007004005000010060050",
    s: "261849735738516249945723618189654372427381596653972184596138427374295861812467953",
    d: -12820,
  },
  {
    p: "261900070090000215300108000047013056000840907080600421000001080050080190014502000",
    s: "261954378498736215375128649947213856126845937583679421739461582652387194814592763",
    d: -12820,
  },
  {
    p: "263794100000680023890000760084509000170400039009107800458310600000000302006900010",
    s: "263794185745681923891253764684539271172468539539127846458312697917846352326975418",
    d: -13181,
  },
  {
    p: "203800059408659700050003000026001008070000090004500217140005960000906000690270380",
    s: "263847159418659723759123846526791438871432695934568217147385962382916574695274381",
    d: -12820,
  },
  {
    p: "060000080500490007790020400957000128840000030010050004083009570409536800625187943",
    s: "264715389531498267798623451957364128842971635316852794183249576479536812625187943",
    d: -12329,
  },
  {
    p: "000790853109384700000502004698010340003458629400036070000073000001020000006145287",
    s: "264791853159384762387562914698217345713458629425936178842673591571829436936145287",
    d: -12329,
  },
  {
    p: "200104830047389600398062147906001400503040260004836500800005000609000014000013900",
    s: "265174839147389652398562147986251473513947268724836591831495726659728314472613985",
    d: -12329,
  },
  {
    p: "205480930000905420900207105530040700427593816096072540052719004000000301004358279",
    s: "265481937173965428948237165531846792427593816896172543352719684789624351614358279",
    d: -12430,
  },
  {
    p: "200150934530004000008073000951307000006805010002006000704681025103500009625730081",
    s: "267158934539264178418973652951327846346895217872416593794681325183542769625739481",
    d: -12654,
  },
  {
    p: "000040059000005600090003071350206700028034096006080103000060200600452937500097008",
    s: "267841359813975642495623871359216784128734596746589123974368215681452937532197468",
    d: -12820,
  },
  {
    p: "007004381010070060005060000129600008070130092800529000090086000651093804308715009",
    s: "267954381413872965985361247129647538576138492834529716792486153651293874348715629",
    d: -12936,
  },
  {
    p: "007950040819043725005170980706004003350000004941030800090400078020080600578369412",
    s: "267958341819643725435172986786514293352897164941236857693421578124785639578369412",
    d: -13250,
  },
  {
    p: "200000751410050900593100048050030002736020514804005009609040185105780030000500007",
    s: "268394751417856923593172648951437862736928514824615379679243185145789236382561497",
    d: -12654,
  },
  {
    p: "008490007000810003090257864430080005159000008080530040920708030810029470600005982",
    s: "268493157547816293391257864436982715159674328782531649924768531815329476673145982",
    d: -13277,
  },
  {
    p: "060500410009100008100060500020000601080320700900410025610943872732681904094250000",
    s: "268539417359174268147862593423795681581326749976418325615943872732681954894257136",
    d: -12329,
  },
  {
    p: "060070140400028035007010620000351200035247000000800450890130507070902300043005900",
    s: "268573149419628735357419628984351276635247891721896453892134567576982314143765982",
    d: -12357,
  },
  {
    p: "000014370051000492700092006000061709000780020400200183604125007197008205500970801",
    s: "269514378851637492743892516328461759915783624476259183684125937197348265532976841",
    d: -13277,
  },
  {
    p: "260730041040260007307459680072810905000940820093625104000082000001070000700000216",
    s: "269738541548261397317459682472813965156947823893625174634182759921576438785394216",
    d: -13277,
  },
  {
    p: "071403080500020430390786205000000108005600072700300000430805901600001753159237864",
    s: "271453689586129437394786215963572148815694372742318596437865921628941753159237864",
    d: -12578,
  },
  {
    p: "271603894048000006390100027405860009000400001007000005052316908100907002800520170",
    s: "271653894548792316396148527425861739983475261617239485752316948134987652869524173",
    d: -12654,
  },
  {
    p: "000800050094000730800064091306010800040006120015270403009080342487923016032640080",
    s: "271839654694152738853764291326415879748396125915278463169587342487923516532641987",
    d: -12953,
  },
  {
    p: "270005490698270050400300027582000004100002570736000982024000010010420006060803000",
    s: "273165498698274351451398627582937164149682573736541982324756819815429736967813245",
    d: -13181,
  },
  {
    p: "200601049100045070645790000317000298020030700900010000000170020002900134831406000",
    s: "273681549189345672645792381317564298426839715958217463594173826762958134831426957",
    d: -12605,
  },
  {
    p: "074009500510784392930105076043917008780650034100030967860090700350800000000000000",
    s: "274369581516784392938125476643917258789652134125438967861293745357841629492576813",
    d: -12329,
  },
  {
    p: "204060510000070900050001630418650009600090754597004060186300200005706003040080100",
    s: "274963518361875942859421637418657329632198754597234861186349275925716483743582196",
    d: -13181,
  },
  {
    p: "274086003608050927500200004036102000040009100701468000465000700100000340329040050",
    s: "274986513618354927593217864936172485842539176751468239465823791187695342329741658",
    d: -12357,
  },
  {
    p: "270000006014827090980405000497206083301078260062543179040002050120009000000004007",
    s: "275391846614827395983465712497216583351978264862543179748632951126759438539184627",
    d: -13277,
  },
  {
    p: "270000130003020040041573900000107800307856004589342601104700000968234715700015000",
    s: "275489136893621547641573982426197853317856294589342671154768329968234715732915468",
    d: -13250,
  },
  {
    p: "206000400031026007090001203760340000325819000400607390083704501100298634040100000",
    s: "276983415531426987894571263769342158325819746418657392983764521157298634642135879",
    d: -13277,
  },
  {
    p: "078143000645970801910000240096000015500019060801405900784501000060830000059700184",
    s: "278143596645972831913658247496287315527319468831465972784591623162834759359726184",
    d: -12953,
  },
  {
    p: "078000000006005000004803126100982030023650900980031000832704090741009863659300270",
    s: "278196345316245789594873126165982437423657918987431652832764591741529863659318274",
    d: -12953,
  },
  {
    p: "078000005600250800135768429000000094004020008010049560402976001793185206501002000",
    s: "278394615649251873135768429826513794954627138317849562482976351793185246561432987",
    d: -12953,
  },
  {
    p: "278400100000850030003006780802000093001903004905000070300140056594000007020090040",
    s: "278439165619857432453216789842571693761983524935624871387142956594368217126795348",
    d: -12475,
  },
  {
    p: "078500190910700205340010008807301000003400502059007001781905020694032007532806010",
    s: "278563194916784235345219768827351946163498572459627381781945623694132857532876419",
    d: -12578,
  },
  {
    p: "009000001086010000340502086410350690000061030003204718030720864007480023824136579",
    s: "279648351586913247341572986418357692792861435653294718135729864967485123824136579",
    d: -12813,
  },
  {
    p: "279060041006371892800209706107050083004000967000007405600400079781593604000020138",
    s: "279865341546371892813249756167954283354182967928637415632418579781593624495726138",
    d: -12813,
  },
  {
    p: "201000059060500000050209006190030504504920160876015093703846000605102378908000000",
    s: "281364759469571832357289416192637584534928167876415293713846925645192378928753641",
    d: -13277,
  },
  {
    p: "200050067400300000009781500500612870070500401010874000104065000765000900000147256",
    s: "281459367457326198639781542543612879876593421912874635124965783765238914398147256",
    d: -12357,
  },
  {
    p: "000030904000000026640728005008200563090073100123645000900007081000382000802051000",
    s: "281536974357194826649728315478219563596873142123645798935467281714382659862951437",
    d: -12820,
  },
  {
    p: "000050179165397200947080003009040710800000032070003894738025060402071380000000927",
    s: "283456179165397248947182653329548716814769532576213894738925461492671385651834927",
    d: -12953,
  },
  {
    p: "203400109410503720000000604040001362107300805300006001004125000031600047928734510",
    s: "283467159416593728759218634845971362167342895392856471674125983531689247928734516",
    d: -12953,
  },
  {
    p: "080905406069410802500802903030086200652300007000001060005640039800009001006127548",
    s: "283975416769413852514862973431786295652394187978251364125648739847539621396127548",
    d: -13277,
  },
  {
    p: "280510600053000210000800459048200090090086005061900780005170904807090560409620870",
    s: "284519637953467218176832459748251396392786145561943782635178924827394561419625873",
    d: -12329,
  },
  {
    p: "004610000007400310190578406009102843042060901805090062020005030006740000400006009",
    s: "284613597567429318193578426679152843342867951815394762721985634936741285458236179",
    d: -13181,
  },
  {
    p: "200010539309008140001003006008050390006300075532709604825970403903264758000000000",
    s: "284617539369528147751493286478156392196342875532789614825971463913264758647835921",
    d: -12953,
  },
  {
    p: "084657001000002000600400750702035100301924060000000520000210475005008916176549230",
    s: "284657391537192684619483752762835149351924867948761523893216475425378916176549238",
    d: -12329,
  },
  {
    p: "204750100090002050006810927025000040940007216001400005400301500008970432050248671",
    s: "284759163197632854536814927725196348943587216861423795472361589618975432359248671",
    d: -12953,
  },
  {
    p: "004010000090000514500400289405396800039000601602001935357000190926007450000500027",
    s: "284915763793628514561473289415396872839752641672841935357284196926137458148569327",
    d: -12654,
  },
  {
    p: "084907300000100954100600070540280639002000005009000240020510790970004020001792408",
    s: "284957316763128954195643872547281639632479185819365247428516793976834521351792468",
    d: -13181,
  },
  {
    p: "284065130309004608176820459765000040008502306403608501041230765630000000500000003",
    s: "284965137359714628176823459765391842918542376423678591841239765632157984597486213",
    d: -12813,
  },
  {
    p: "285030479030000000701804260104592008000071090900680050300005000008009040670000010",
    s: "285136479436927581791854263164592738853471692927683154349715826518269347672348915",
    d: -12475,
  },
  {
    p: "005030069409200817010009300502006700761320905090754000004070200800400500903580600",
    s: "285137469439265817617849352542916783761328945398754126154673298876492531923581674",
    d: -12357,
  },
  {
    p: "085000364970408512004265900840691250090000641002050890029503400050742000000000005",
    s: "285179364976438512314265978847691253593827641162354897729513486658742139431986725",
    d: -12329,
  },
  {
    p: "286104000105902008004050006610400700029576000047000009000009270800647900003210080",
    s: "286134597175962438934758126618493752329576841547821369461389275852647913793215684",
    d: -12820,
  },
  {
    p: "286100049904850720730249016040320060000061000103594000450980672002615400000000000",
    s: "286137549914856723735249816547328961829761354163594287451983672372615498698472135",
    d: -12329,
  },
  {
    p: "000009000704080091039004002347028109028061007060340020470802900002030708810006054",
    s: "286159473754283691139674582347528169528961347961347825475812936692435718813796254",
    d: -12936,
  },
  {
    p: "200000579014956008000000064849060720500010893102090045058000310000005407400128956",
    s: "286341579714956238395782164849563721567214893132897645658479312921635487473128956",
    d: -12329,
  },
  {
    p: "280050047945000000300200506000005068008030251021780000050090600090862370802500014",
    s: "286359147945617823317248596439125768678934251521786439753491682194862375862573914",
    d: -12605,
  },
  {
    p: "200403795704902000391500000572001308800300007600058902437000820968000001000030076",
    s: "286413795754982163391576284572691348819324657643758912437165829968247531125839476",
    d: -12936,
  },
  {
    p: "006431000045790060019200000960000827420003050000027046602310584100004279094072600",
    s: "286431795345798162719256438963145827427683951851927346672319584138564279594872613",
    d: -13277,
  },
  {
    p: "200004593010720000000800000142568309060902051009400028090045032000087905753006184",
    s: "287614593915723846634859217142568379368972451579431628896145732421387965753296184",
    d: -13277,
  },
  {
    p: "280173046000004802014062730400091070007000900960020400030405000700236104106009305",
    s: "289173546673954812514862739458691273327548961961327458832415697795236184146789325",
    d: -12936,
  },
  {
    p: "280010500006745902040289301702034010008070000060002090000098140100407638800160000",
    s: "289316574316745982547289361752934816938671425461852793623598147195427638874163259",
    d: -12357,
  },
  {
    p: "209000050407008000500042708090000200600807040008420030700200016961784503852613974",
    s: "289376451417958362536142798394561287625837149178429635743295816961784523852613974",
    d: -12329,
  },
  {
    p: "280075100703010659010040280021000000000400800560390400000080003956130708830567901",
    s: "289675134743812659615943287421758396397426815568391472174289563956134728832567941",
    d: -12936,
  },
  {
    p: "000006840730500009050004073502003000400207381308609020000902750020030160040081902",
    s: "291376845734528619856194273572813496469257381318649527183962754927435168645781932",
    d: -12605,
  },
  {
    p: "001000800375100000600093075407025016910030050030070084060009000059310468104006509",
    s: "291567843375148692648293175487925316916834257532671984863459721759312468124786539",
    d: -12357,
  },
  {
    p: "291600000400950120300127609510098060000000050083041097705809436130460000006000005",
    s: "291684573467953128358127649512798364974236851683541297725819436139465782846372915",
    d: -12936,
  },
  {
    p: "094308057600000030573004802830071000000000300100650784701000093300507041940036570",
    s: "294368157618725439573914862835471926467289315129653784751842693386597241942136578",
    d: -12936,
  },
  {
    p: "200018300860907500050060002517200869640080000308009000406701200072836045005002000",
    s: "294518376863927514751364982517243869649185723328679451436751298972836145185492637",
    d: -12357,
  },
  {
    p: "000001080000260900506839000703490008608000010940150300807010090000082031100705026",
    s: "294571683381264975576839142713496258658327419942158367827613594465982731139745826",
    d: -13007,
  },
  {
    p: "094573600850069430036000590407001300120050060005498020013002046602005000000030205",
    s: "294573618851269437736814592487621359129357864365498721513782946672945183948136275",
    d: -12936,
  },
  {
    p: "004708600006400002001265080040300506038010004159600030800907025405000060027156843",
    s: "294738651586491372371265489742389516638512794159674238863947125415823967927156843",
    d: -12654,
  },
  {
    p: "290800300000000046786500200020000100100009482647000903875200004310645700009008000",
    s: "294816375531927846786534219928453167153769482647182953875291634312645798469378521",
    d: -13007,
  },
  {
    p: "205100080060924005007600030500702000601400350870503426082000090004050000000809043",
    s: "295137684368924175417685932543762819621498357879513426782346591934251768156879243",
    d: -13007,
  },
  {
    p: "095300460070005089086000573000958020010460097940271006760000005054709032009006000",
    s: "295387461371645289486192573637958124512463897948271356763824915854719632129536748",
    d: -12936,
  },
  {
    p: "295014000040030090600029054510002943080495061070060002820306479053240610000000305",
    s: "295614837147538296638729154516872943382495761479163582821356479953247618764981325",
    d: -12953,
  },
  {
    p: "200000374801030000734059010107000003009302000300008145000795600002803400600024930",
    s: "295681374861437529734259816187546293549312768326978145413795682972863451658124937",
    d: -12820,
  },
  {
    p: "000784310781936040000000079650090000007600008300578001516207003870009054000860120",
    s: "295784316781936245463152879658491732147623598329578461516247983872319654934865127",
    d: -12936,
  },
  {
    p: "095800604007006508861030002104009860980013450536048120000090300010067080053000070",
    s: "295871634347926518861534792174259863982613457536748129728195346419367285653482971",
    d: -12654,
  },
  {
    p: "000108703018000000754230090060004021020000374403900080000050207130809045002001009",
    s: "296148753318597462754236198865374921921685374473912586689453217137829645542761839",
    d: -13007,
  },
  {
    p: "200047851800061490001008036920706000300495002000020000400600010100502980089074620",
    s: "296347851853261497741958236925716348378495162614823579432689715167532984589174623",
    d: -12357,
  },
  {
    p: "000084703048301609000962080167098302302610048489005060021003000000050200075126000",
    s: "296584713548371629713962485167498352352617948489235167821743596634859271975126834",
    d: -12329,
  },
  {
    p: "297301000000702000063409007750908000008100490000540728800694002972803604346205080",
    s: "297351846481762539563489217754928163628137495139546728815694372972813654346275981",
    d: -12953,
  },
  {
    p: "090405008010203409403100000700092060008037002000000780040008617530700804070006250",
    s: "297465138615283479483179526754892361168537942329614785942358617536721894871946253",
    d: -13007,
  },
  {
    p: "297631005030050000010280900051042836000006250302508004006470009400065017070120608",
    s: "297631485834957162615284973951742836748396251362518794186473529429865317573129648",
    d: -12329,
  },
  {
    p: "090004306000000289000629010600002908900350067000000021086040090400981673319765842",
    s: "297814356164537289538629714645172938921358467873496521786243195452981673319765842",
    d: -12329,
  },
  {
    p: "208460100630020594754130268060300001027080000840090000015703600070010030002900400",
    s: "298465173631827594754139268569372841127684359843591726915743682476218935382956417",
    d: -13181,
  },
  {
    p: "010075009072080030809312746706000005000107004091004070903050010060003802020001653",
    s: "314675289672489531859312746746938125538127964291564378983256417165743892427891653",
    d: -12357,
  },
  {
    p: "300009206008160900900000041702001065090270408830005700057930104403007609009408037",
    s: "314789256528164973976352841742891365695273418831645792257936184483517629169428537",
    d: -12654,
  },
  {
    p: "004906020025340961070520308431708000500039084980154030000403076043600819000800000",
    s: "314986725825347961679521348431768592567239184982154637158493276243675819796812453",
    d: -12953,
  },
  {
    p: "305086040200009500904537080450002790123000000897004000689073125040020609532001870",
    s: "315286947278149563964537281456312798123798456897654312689473125741825639532961874",
    d: -12578,
  },
  {
    p: "006700594045301070780004013030976480000405900094208300050600709070159800903047100",
    s: "316782594245391678789564213531976482827435961694218357158623749472159836963847125",
    d: -12953,
  },
  {
    p: "007520068490100300000000504030617802009005631008090745071000480056041073840006150",
    s: "317524968495168327682739514534617892729485631168392745271953486956841273843276159",
    d: -13277,
  },
  {
    p: "007600000006210047082705160024100395900430008163958070709000082648300750051000000",
    s: "317684529596213847482795163824176395975432618163958274739561482648329751251847936",
    d: -12329,
  },
  {
    p: "017050400560002301000060759200001900070000136031607528604005807008070043703284600",
    s: "317859462569742381842163759286531974975428136431697528624315897158976243793284615",
    d: -13277,
  },
  {
    p: "300269054240007098005008623004702800532400970080900042860500200020001006051623000",
    s: "318269754246357198975148623194732865532486971687915342863594217429871536751623489",
    d: -13277,
  },
  {
    p: "000540002057009068000078035642050009570980641080030507001400806825063914760000000",
    s: "318546792257319468496278135642157389573982641189634527931425876825763914764891253",
    d: -12329,
  },
  {
    p: "009020076000760010006010204205901307000247605074005008427803060000102009190000780",
    s: "319524876542768913786319254265981347831247695974635128427893561658172439193456782",
    d: -13181,
  },
  {
    p: "300050040524301008076000531000500210091602305052103809100430027000900483943720000",
    s: "319857642524361798876294531638579214491682375752143869185436927267915483943728156",
    d: -12953,
  },
  {
    p: "009000642078000050502603009851360200200048000034200700093586400420000500185024006",
    s: "319875642678492153542613879851367294267948315934251768793586421426139587185724936",
    d: -12936,
  },
  {
    p: "301687945065319208000005013830006709000208000100090804010064007708050100000701482",
    s: "321687945465319278987425613832146759594278361176593824213864597748952136659731482",
    d: -13277,
  },
  {
    p: "001000465976000030408610002600000803000035610003196000700080920860000000005702004",
    s: "321978465976254138458613792619427853247835619583196247734581926862349571195762384",
    d: -12641,
  },
  {
    p: "320105070070023090010467503051900002080000940003080000560709800008254700140600009",
    s: "324195678675823491819467523751946382286371945493582167562719834938254716147638259",
    d: -12605,
  },
  {
    p: "300000001809045000065003709048000070500074092730950010601530800207000006403621950",
    s: "324769581879145263165283749948312675516874392732956418691537824257498136483621957",
    d: -13181,
  },
  {
    p: "304000067000004013060253000905028146010075009043100875030642001192537080050800000",
    s: "324981567589764213761253498975328146618475329243196875837642951192537684456819732",
    d: -13277,
  },
  {
    p: "025009847640587123087234056000300710871945362000000005008096270000000698060070501",
    s: "325619847649587123187234956456328719871945362293761485538196274712453698964872531",
    d: -12813,
  },
  {
    p: "020960010000005093170403060083056479960720030751394628090600040407509000030041957",
    s: "325967814846215793179483562283156479964728135751394628598672341417539286632841957",
    d: -12813,
  },
  {
    p: "320090400705021800001060372218037009500480700000005000670000280000873900804000107",
    s: "326798451745321896981564372218637549569482713437915628673149285152873964894256137",
    d: -12820,
  },
  {
    p: "300008596600050823958003471560000900709501284840007060400000050090470010100890342",
    s: "327148596614759823958623471561284937739561284842937165486312759293475618175896342",
    d: -12953,
  },
  {
    p: "327809450406205800008407032705026090060074015000050004601792543073500009050000000",
    s: "327819456496235871518467932745126398869374215132958764681792543273541689954683127",
    d: -12329,
  },
  {
    p: "020106940061005007059400000870000356006000472530700009603080704907641503040390068",
    s: "328176945461935287759428631874219356196853472532764819613582794987641523245397168",
    d: -13277,
  },
  {
    p: "320746109947050086001902003000690021260318590019000300132400870090000610806000000",
    s: "328746159947153286651982743783695421264318597519274368132469875495837612876521934",
    d: -13277,
  },
  {
    p: "000175600008009050000860023506720000084003065030506200602487010003600000910052846",
    s: "329175684468239157175864923596728431284913765731546298652487319843691572917352846",
    d: -13181,
  },
  {
    p: "329008100700300549040197000906080423000029005102050098597210030000800007003000050",
    s: "329548176781362549645197382956781423438629715172453698597216834214835967863974251",
    d: -12605,
  },
  {
    p: "020067000510094602400000500052800004940750083080409705000002800001000000000183956",
    s: "329567418518394672467218539752836194946751283183429765635972841891645327274183956",
    d: -12475,
  },
  {
    p: "000605090280030007907082030504090063079310540163000700630000005708503904000021000",
    s: "341675298286139457957482631524798163879316542163254789632947815718563924495821376",
    d: -12605,
  },
  {
    p: "041692000020470310000831000080060037036100080417300065203000801690010542154280000",
    s: "341692758829475316765831429582964137936157284417328965273546891698713542154289673",
    d: -12329,
  },
  {
    p: "300020008900400720076300000050003002000271006604908001519804230062100085708502100",
    s: "341729658985416723276385419157643892893271546624958371519864237462137985738592164",
    d: -13181,
  },
  {
    p: "040700000709840000600001904804603002970584061000000840003002580518390420000450109",
    s: "341769258729845613685231974854613792972584361136927845493172586518396427267458139",
    d: -12357,
  },
  {
    p: "340782050090000000702900130009308705803000640200497301004200017087000062025070493",
    s: "341782956598613274762945138419368725873521649256497381634259817987134562125876493",
    d: -12654,
  },
  {
    p: "300000005002490310006003247010000050459270600723005480007000004965000020284359006",
    s: "341827965572496318896513247618934752459278631723165489137682594965741823284359176",
    d: -13181,
  },
  {
    p: "340501000019400050000937200201798005400052180000004900903005600100009072806103094",
    s: "342581769719426853685937241261798435497352186538614927973245618154869372826173594",
    d: -12357,
  },
  {
    p: "302086109589400203701000048007108035000000704054367092000010400010703980906004301",
    s: "342586179589471263761932548297148635638295714154367892823619457415723986976854321",
    d: -12329,
  },
  {
    p: "042057610068934725000000004406013072200400030003002100034780090800000050597041863",
    s: "342857619168934725975126384486513972219478536753692148634785291821369457597241863",
    d: -13277,
  },
  {
    p: "002900086168435902905862400800001000027608030000374020280000301700589260004003700",
    s: "342917586168435972975862413893251647427698135516374829289746351731589264654123798",
    d: -13277,
  },
  {
    p: "042017058607400300098602010270508106100200005080360090900720004000800060004000973",
    s: "342917658617485329598632417279548136136279845485361792961723584753894261824156973",
    d: -12605,
  },
  {
    p: "342900000706050020019072084060080097000009800090061450401020509008003042920040630",
    s: "342918765786354921519672384163485297254739816897261453431826579678593142925147638",
    d: -12357,
  },
  {
    p: "000100000090800014610090025004970230906040001002301008403000900800430507760502000",
    s: "345126879297853614618794325184975236936248751572361498453617982821439567769582143",
    d: -12475,
  },
  {
    p: "305060071810407050200150840968510320000086500150000000690040030480305062030021408",
    s: "345862971819437256276159843968514327723986514154273689692748135481395762537621498",
    d: -12329,
  },
  {
    p: "040079602800106304610000098030084200478900001000000049000693000003001020000058170",
    s: "345879612897126354612435798139584267478962531256317849721693485583741926964258173",
    d: -13168,
  },
  {
    p: "040018200182036005009204800007485000830009000050623700098300154473500680000802970",
    s: "345918267182736495769254831627485319834179526951623748298367154473591682516842973",
    d: -12329,
  },
  {
    p: "340906018208450600000810052400008900900072504002509876000001065003000109001394287",
    s: "345926718218457693679813452457638921986172534132549876794281365823765149561394287",
    d: -13277,
  },
  {
    p: "006508910070030502250407060010940023030170650002053000020381006600094000193700000",
    s: "346528917871639542259417368715946823438172659962853471524381796687294135193765284",
    d: -12357,
  },
  {
    p: "006025000000460208982700465600257300835601072021090546009000000418000053003100009",
    s: "346825197157469238982713465694257381835641972721398546279536814418972653563184729",
    d: -12654,
  },
  {
    p: "046050029000409103000630008623084005108260400075090280500000072000008090060042800",
    s: "346851729857429163912637548623784915198265437475193286584916372231578694769342851",
    d: -12820,
  },
  {
    p: "000009052871250006059300007004907268102538000708020315003005800080003009010702000",
    s: "346879152871254936259361487534917268162538794798426315423695871687143529915782643",
    d: -13181,
  },
  {
    p: "040060920050832170821790300193206507685007002074005013412609030009000001000020000",
    s: "347561928956832174821794356193246587685317492274985613412679835739458261568123749",
    d: -13277,
  },
  {
    p: "300009000050000108000064000000105204908640700400092603804200001500400069130908050",
    s: "347819526659327148281564937763185294928643715415792683894256371572431869136978452",
    d: -12641,
  },
  {
    p: "340060000908023060260500834000287490020634057000095280003702048004058370700300019",
    s: "347861925958423761261579834135287496829634157476195283593712648614958372782346519",
    d: -12953,
  },
  {
    p: "300000160100046738760001520000502000082070415000604300001460800876005043934728600",
    s: "348257169125946738769831524413582976682379415597614382251463897876195243934728651",
    d: -12329,
  },
  {
    p: "348560000091003602000000030000600320436270195200309046000830760983020014060950203",
    s: "348562971791483652652197438819645327436278195275319846524831769983726514167954283",
    d: -13277,
  },
  {
    p: "040560009001000060967100400020970048509604071800251006710000004083702000490316780",
    s: "348567129251439867967128453126973548539684271874251396712895634683742915495316782",
    d: -12654,
  },
  {
    p: "300010579700080120200500004174000080906800405003200007015320098007156300002790050",
    s: "348612579759483126261579834174965283926837415583241967615324798897156342432798651",
    d: -12357,
  },
  {
    p: "040008506000000934000903100030000002920005400050074690205001069618390200493026780",
    s: "349718526187652934562943178734169852926835417851274693275481369618397245493526781",
    d: -13181,
  },
  {
    p: "300000067002000005070056140080430076046002091700610050890023614600500729007004503",
    s: "351248967462197835978356142189435276546872391723619458895723614634581729217964583",
    d: -12936,
  },
  {
    p: "001206000806007051079051080617003425900010063035704198084000506593678200000005009",
    s: "351286947826947351479351682617893425948512763235764198784129536593678214162435879",
    d: -12578,
  },
  {
    p: "350280460290340058006951700405000690000590070700000345500002000073865204104000000",
    s: "351287469297346158846951723485173692632594871719628345568412937973865214124739586",
    d: -13181,
  },
  {
    p: "051406098004391065092850010015609340847130659000074080009008000003045000000010070",
    s: "351426798784391265692857413215689347847132659936574182429768531173945826568213974",
    d: -12654,
  },
  {
    p: "301820460704060320290000000103009604040030501500000900475000090839572100602493758",
    s: "351827469784961325296345817123759684948236571567184932475618293839572146612493758",
    d: -12953,
  },
  {
    p: "000040067048007300069005040197658000500309070002070900010094732023010090070083000",
    s: "351942867248167359769835241197658423584329176632471985816594732423716598975283614",
    d: -12820,
  },
  {
    p: "302000704906001008017400639003040800000058200500130400100000902089612005000794000",
    s: "352869714946371528817425639693247851471958263528136497164583972789612345235794186",
    d: -13007,
  },
  {
    p: "300901746070065000060002805030000408500000920047129600100000080724098561003514279",
    s: "352981746978465132461732895239657418516843927847129653195276384724398561683514279",
    d: -13277,
  },
  {
    p: "054609108006120000001458960670080010108296074009007682407035090200061840060000000",
    s: "354679128986123457721458963672584319138296574549317682417835296293761845865942731",
    d: -13277,
  },
  {
    p: "054901060008540309270030100013470500000385017045010000400700005007850000502000973",
    s: "354921768168547329279638154813476592926385417745219836431792685697853241582164973",
    d: -12605,
  },
  {
    p: "300978000721635000000000030007000190102790008000040673003061829295480361016309740",
    s: "354978216721635984968214537647853192132796458589142673473561829295487361816329745",
    d: -12953,
  },
  {
    p: "050000000801002500020380610000096000090000402032450006580024361764903258213568749",
    s: "356149827841672593927385614478296135695831472132457986589724361764913258213568749",
    d: -12578,
  },
  {
    p: "300010870100600239090004100001948002000523700005007040010070406072000010603450020",
    s: "356219874147685239298734165731948652864523791925167348519372486472896513683451927",
    d: -13007,
  },
  {
    p: "000000080201580090000701000034020000002000706500604210160930470740800502003070061",
    s: "356249187271583694498761325634127859912358746587694213165932478749816532823475961",
    d: -12641,
  },
  {
    p: "356040198920100400081305007000000009003609500000010006004007081078420050035981760",
    s: "356742198927168435481395627762854319813679542549213876694537281178426953235981764",
    d: -13181,
  },
  {
    p: "006901708480000950009002000021038600000020185000100037007450800214803090000219074",
    s: "356941728482367951179582463521738649793624185648195237937456812214873596865219374",
    d: -12605,
  },
  {
    p: "300006008640700030109435002500604807006053000008170000961000005000562100270001346",
    s: "357216498642798531189435762593624817716853924428179653961347285834562179275981346",
    d: -12605,
  },
  {
    p: "307096000010300706020018000095000810000500400108002600602040985030870264500029000",
    s: "357296148819354726426718539295467813763581492148932657672143985931875264584629371",
    d: -13007,
  },
  {
    p: "000000900698500070040709308080670020900002400020000536070215043210846005065097812",
    s: "357428961698531274142769358584673129936152487721984536879215643213846795465397812",
    d: -12654,
  },
  {
    p: "057640921008032000002901503539006010420310000800204060103000000200095137005000402",
    s: "357648921918532746642971583539786214426319875871254369193427658264895137785163492",
    d: -13181,
  },
  {
    p: "307020401040010050000040792470030080269070500800002047583000070104950000090384105",
    s: "357829461942716358618543792471635289269478513835192647583261974124957836796384125",
    d: -13181,
  },
  {
    p: "300670009010082000600591048000010720106720094000809050560140000074938000081256000",
    s: "358674219419382675627591348895413726136725894742869153563147982274938561981256437",
    d: -12357,
  },
  {
    p: "050017004862350970400000350904030200008045000500000097103002509200503008645891732",
    s: "359617824862354971471289356914736285728945613536128497183472569297563148645891732",
    d: -13277,
  },
  {
    p: "300670400004020000826309750018230590000856210205000608700005000092003060403190805",
    s: "359671482174528936826349751618234597947856213235917648781465329592783164463192875",
    d: -12936,
  },
  {
    p: "000270804000063921280045630008090140006580379930000208003407500050000402600950713",
    s: "361279854574863921289145637728396145416582379935714268193427586857631492642958713",
    d: -12329,
  },
  {
    p: "004059078807000010091007500006012487142003600900500120600400752405060001709235840",
    s: "364159278857624319291387564536912487142873695978546123683491752425768931719235846",
    d: -12953,
  },
  {
    p: "300700002050009000297004056486193720009508613135670040600930271072800304013400000",
    s: "364751982851269437297384156486193725729548613135672849648935271572816394913427568",
    d: -13250,
  },
  {
    p: "005090200800700100700080659027608093934000816100040700009006340000027001078001002",
    s: "365194278892765134741283659527618493934572816186349725219856347653427981478931562",
    d: -12820,
  },
  {
    p: "300297018000001020014586900000000089000600742480109060571902030900000601830005097",
    s: "365297418798341526214586973623754189159638742487129365571962834942873651836415297",
    d: -13181,
  },
  {
    p: "365000841900018302000053096002000937703205100006309008607001280409000015218500070",
    s: "365792841974618352821453796582164937793285164146379528657941283439827615218536479",
    d: -12329,
  },
  {
    p: "305000000082701365010300000040006002609017480503000009050004031206170594194253876",
    s: "365829147982741365417365928841936752629517483573482619758694231236178594194253876",
    d: -12953,
  },
  {
    p: "000004829802060040045800160438020007620705400050908600000150390006093500000406001",
    s: "367514829812369745945872163438621957629735418751948632284157396176293584593486271",
    d: -12605,
  },
  {
    p: "000400000407206380902000407003182500080005030100309872029050713534617090000923650",
    s: "368471925457296381912538467793182546286745139145369872629854713534617298871923654",
    d: -12953,
  },
  {
    p: "368004010104306200025070460030040621006200904000609000003968002097102800280400396",
    s: "368524719174396258925871463839745621756213984412689537543968172697132845281457396",
    d: -12329,
  },
  {
    p: "000010085020000409018090300205308160070050238030240050700034001006025073050709042",
    s: "369412785527863419418597326295378164674951238831246957782634591946125873153789642",
    d: -12357,
  },
  {
    p: "300004900500607001698301470846130050000400083907000204480003026100058047000000000",
    s: "371584962524697831698321475846132759215479683937865214489713526162958347753246198",
    d: -12820,
  },
  {
    p: "070050080084002071160387000837200015040060000200000700000816527008900164621475893",
    s: "372154986584692371169387452837249615945761238216538749493816527758923164621475893",
    d: -12953,
  },
  {
    p: "300008040681400297540710068265987000000100802003524679908000020130270980726040003",
    s: "372698145681453297549712368265987431497136852813524679958361724134275986726849513",
    d: -12813,
  },
  {
    p: "002010508000200017081305040097402106004007005200008794968021073005060289703809000",
    s: "372914568549286317681375942897452136134697825256138794968521473415763289723849651",
    d: -13277,
  },
  {
    p: "304000006560000321008530497683001240000050000050084070715003000800015032402760059",
    s: "374129586569847321128536497683971245947352618251684973715293864896415732432768159",
    d: -12936,
  },
  {
    p: "370000801802031005501020903405000000120000650006900302900208000000046097053097204",
    s: "374569821892731465561824973435682719129473658786915342947258136218346597653197284",
    d: -12820,
  },
  {
    p: "300025801000037625000981340401500003060300084809274050007803060000750008000006739",
    s: "374625891918437625256981347421568973765319284839274156147893562693752418582146739",
    d: -12936,
  },
  {
    p: "000960125109420006006730904062500019503040000890010000008396051921850003630072490",
    s: "374968125189425736256731984462587319513249867897613542748396251921854673635172498",
    d: -12578,
  },
  {
    p: "005000060000006302040081597012038754000200810087014000120007680000092030954860200",
    s: "375429168891756342246381597612938754439275816587614923123547689768192435954863271",
    d: -13181,
  },
  {
    p: "375000010020500060600092305250100983067309104000204076500800091030007008706900002",
    s: "375648219429531867618792345254176983867359124193284576542863791931427658786915432",
    d: -12357,
  },
  {
    p: "005604200092701006810000030038000047000003610000470382000009503020508160600307420",
    s: "375684291492731856816952734538126947247893615961475382184269573723548169659317428",
    d: -12820,
  },
  {
    p: "376012059040097601098305020003080000964001003780639010000700502029000378857923006",
    s: "376412859245897631198365724513284967964571283782639415631748592429156378857923146",
    d: -13250,
  },
  {
    p: "300001509008706002904803000500100027289007106000209850005302000042600390830974000",
    s: "376421589158796432924853671563148927289537146417269853695382714742615398831974265",
    d: -12357,
  },
  {
    p: "370081900900600701801570004002806090004257010008903006107395200000000030403100600",
    s: "376481952945632781821579364532816497694257813718943526167395248289764135453128679",
    d: -12605,
  },
  {
    p: "078040000205780410000392780004009070917200030603471092461007308052010040009000120",
    s: "378145269295786413146392785524639871917258634683471592461927358752813946839564127",
    d: -13277,
  },
  {
    p: "308109250126007000509032167001420805853971600294650300000294508982010000000000000",
    s: "378169254126547983549832167761423895853971642294658371637294518982715436415386729",
    d: -12578,
  },
  {
    p: "378240050600375098950000374810000720037620009294000683460781030000090860700000000",
    s: "378249156641375298952816374816934725537628419294157683469781532125493867783562941",
    d: -12329,
  },
  {
    p: "078419520009260700026700009850070100001508600060041800000800060683000241742136985",
    s: "378419526419265738526783419854672193231598674967341852195824367683957241742136985",
    d: -12578,
  },
  {
    p: "008061000200049701109302000800600510490000060007020004030050128682417953915238476",
    s: "378561249256849731149372685823694517491785362567123894734956128682417953915238476",
    d: -13250,
  },
  {
    p: "300120000105837000200000137013489625052000094006253718604300000031600080000041263",
    s: "379124856165837942248965137713489625852716394496253718624398571531672489987541263",
    d: -12953,
  },
  {
    p: "370105068045908207802307000000539100230470089501002000013890052000206000420003000",
    s: "379125468145968237862347915784539126236471589591682374613894752957216843428753691",
    d: -12936,
  },
  {
    p: "300058040608394071501007803200401980980230010007009230000012060000986054060003109",
    s: "379158642628394571541627893253471986986235417417869235794512368132986754865743129",
    d: -13277,
  },
  {
    p: "000006574004000200057040008076005030000794000010608750105362047000580390608479105",
    s: "381926574964857213257143968876215439523794681419638752195362847742581396638479125",
    d: -12936,
  },
  {
    p: "300050690547069000106008000729683540061007009000001006908400005075000830614835972",
    s: "382154697547369218196728453729683541861547329453291786938472165275916834614835972",
    d: -12953,
  },
  {
    p: "082056090000372650750010043003040960810600300000030080907060800020580409008003726",
    s: "382456197194372658756918243273845961815629374469731582937264815621587439548193726",
    d: -13181,
  },
  {
    p: "380064157056207039010835000001650700200000503500023000708001060600070901100080372",
    s: "382964157456217839917835246831659724269748513574123698728391465643572981195486372",
    d: -12936,
  },
  {
    p: "000279000571360829900150040400090508700503264005000703000006001136485972207931000",
    s: "384279156571364829962158347423697518798513264615842793859726431136485972247931685",
    d: -12578,
  },
  {
    p: "380500091697010005005080700460200003073098140800743000140000907730904000950070030",
    s: "384567291697412385215389764469251873573698142821743659146835927738924516952176438",
    d: -12357,
  },
  {
    p: "300006291710809300609100070071623040065014700243078900590300000406087059107490003",
    s: "384756291712849365659132874971623548865914732243578916598361427436287159127495683",
    d: -13250,
  },
  {
    p: "005924006000508300062703890010605238826000409953840107230406001071209580000000000",
    s: "385924716197568342462713895714695238826371459953842167238456971671239584549187623",
    d: -12953,
  },
  {
    p: "306000000005006001020000508600903020001062007800471093208140050000320009410609700",
    s: "386215974745896231129734568674983125931562847852471693298147356567328419413659782",
    d: -12475,
  },
  {
    p: "086051204479020651005000983058040000043700000020300008102080730890200105530070000",
    s: "386951274479823651215467983958642317643718592721395468162584739897236145534179826",
    d: -13181,
  },
  {
    p: "309470016007081000040009087432100608010825470805300001793000000650000002124703869",
    s: "389472516267581394541639287432197658916825473875346921793268145658914732124753869",
    d: -12953,
  },
  {
    p: "300561702000007319701000560070653081104078950538000000090785130010306000800090076",
    s: "389561742625847319741932568972653481164278953538419627296785134417326895853194276",
    d: -13277,
  },
  {
    p: "309605742420008516560400008650130290070580360093002050800903000000800000000246189",
    s: "389615742427398516561427938658134297274589361193762854816973425942851673735246189",
    d: -12329,
  },
  {
    p: "380002500000009000057800010008643007001200940764000802812075000605030001403006785",
    s: "389712564146359278257864319928643157531287946764591832812475693675938421493126785",
    d: -12605,
  },
  {
    p: "390047580685000027402050003148005900067103054000084070724500310530009008010030005",
    s: "391247586685391427472856193148675932967123854253984671724568319536719248819432765",
    d: -13277,
  },
  {
    p: "001605480500009060000183579006040800200000050013500700068014005070006918135298647",
    s: "391675482587429361624183579756941823249837156813562794968714235472356918135298647",
    d: -12329,
  },
  {
    p: "390050600072006300600201790030000967940063801068100050050010200406082579723945186",
    s: "391758642572496318684231795135824967947563821268179453859617234416382579723945186",
    d: -12813,
  },
  {
    p: "394102058000048100780090240009800070600000400057014809000000360000026507405087900",
    s: "394162758526748193781593246149835672638279415257614839872951364913426587465387921",
    d: -12820,
  },
  {
    p: "004002870100458030020397061049023010000040000000700590700634209902500000083079006",
    s: "394162875176458932825397461549823617617945328238716594751634289962581743483279156",
    d: -12605,
  },
  {
    p: "000100200026705000750920010645097320000000560000456897009014780470600153031002040",
    s: "394168275126745938758923416645897321987231564213456897569314782472689153831572649",
    d: -12654,
  },
  {
    p: "004078516007906804600050009070065000800042061002080307040500728780004000021000603",
    s: "394278516257916834618453279179365482835742961462189357946531728783624195521897643",
    d: -12605,
  },
  {
    p: "304070206205468000100030500080050630002043107001020408500790043040000700827314965",
    s: "394571286275468319168239574489157632652843197731926458516792843943685721827314965",
    d: -13277,
  },
  {
    p: "004600702108020004006008001080301007432000010500000030000182673200704000007563400",
    s: "394615782158927364726438591689351247432876915571249836945182673263794158817563429",
    d: -12475,
  },
  {
    p: "000672018500190740000548600253407000070209305000305070041000020800031067607804051",
    s: "394672518568193742712548639253487196476219385189365274941756823825931467637824951",
    d: -12654,
  },
  {
    p: "090704620871006954002000030040102083006438592008500040600200410100050360003600075",
    s: "395784621871326954462915837549162783716438592238579146657293418124857369983641275",
    d: -12654,
  },
  {
    p: "300702000400100000010000006000050210009210087128479630074020068052367194631984000",
    s: "396742851485196723217835946743658219569213487128479635974521368852367194631984572",
    d: -12329,
  },
  {
    p: "090002000081406700405000900012549007000000016030080290104308600708024035000065470",
    s: "396752841281496753475813962612549387849237516537681294154378629768924135923165478",
    d: -12820,
  },
  {
    p: "397020580060583701815070623030200408248700106000001200000007005070418360080052917",
    s: "397126584462583791815974623931265478248739156756841239123697845579418362684352917",
    d: -13250,
  },
  {
    p: "000000600456070013280640050100930020600801900030060180000308265900016070005700001",
    s: "397185642456279813281643759148937526672851934539462187714398265923516478865724391",
    d: -13007,
  },
  {
    p: "300028560000105070200709000900007040405000710702643805080074900670001024504096007",
    s: "397428561846135279251769438938517642465982713712643895183274956679851324524396187",
    d: -13181,
  },
  {
    p: "300480260682935000450206803576300000140052036239018574820007600910000000000000358",
    s: "397481265682935741451276893576394182148752936239618574823547619915863427764129358",
    d: -12578,
  },
  {
    p: "397080021016392800000100060009020030802563004050000278908706000004000783030400090",
    s: "397685421416392857285174369149827536872563914653941278928736145564219783731458692",
    d: -12605,
  },
  {
    p: "090070000752081390461003702905067040000030910000900030020810470876054009000709006",
    s: "398472561752681394461593782935167248684235917217948635529816473876354129143729856",
    d: -13181,
  },
  {
    p: "090006245054000160600080009000047600147090853003000090012070506800120000570400021",
    s: "398716245754239168621584739985347612147692853263851497412973586836125974579468321",
    d: -12820,
  },
  {
    p: "398700406051048973476900020980060230100274050007089041802093065600807002000000000",
    s: "398752416251648973476931528984165237163274859527389641812493765645817392739526184",
    d: -12953,
  },
  {
    p: "000000703000200061000104502300406010080375024240001070500012947029040150070908200",
    s: "412569783895237461763184592357426819981375624246891375538612947629743158174958236",
    d: -12605,
  },
  {
    p: "412600807680007010750140006005006080300591060160000059530910008071302600000065391",
    s: "412659837689237514753148926295476183348591762167823459536914278971382645824765391",
    d: -13277,
  },
  {
    p: "002080075860000014053100862000064720000000009940700508007400083534800290100370400",
    s: "412683975869257314753149862385964721271538649946721538627495183534816297198372456",
    d: -12605,
  },
  {
    p: "002700008607150029000006000083000912000802350024000706040387005058249070200015840",
    s: "412793568637158429895426137783564912961872354524931786146387295358249671279615843",
    d: -13181,
  },
  {
    p: "412008050800450900907000002709040028140280005020079400005800210000907004004006307",
    s: "412798653863452971957361842739645128146283795528179436675834219381927564294516387",
    d: -12820,
  },
  {
    p: "410830567500407390970506800300042700006903415800050036180300602600200070000060053",
    s: "412839567568427391973516824351642789726983415894751236189375642635294178247168953",
    d: -13277,
  },
  {
    p: "410900002052800940068042710080230167170605038200180590820069001640758020000000000",
    s: "413976852752813946968542713589234167174695238236187594825369471641758329397421685",
    d: -12953,
  },
  {
    p: "415069000006070500009050060007900450902610370001007006098406137003098045670531890",
    s: "415269783236874519789153264367982451942615378851347926598426137123798645674531892",
    d: -12953,
  },
  {
    p: "005600700600000051009105634391800400000000010028004560836049120050301006102568090",
    s: "415632789683497251279185634391856472564273918728914563836749125957321846142568397",
    d: -12936,
  },
  {
    p: "015600980000150060030000750748916500000000090053004017370508206060020809009007105",
    s: "415673982897152364632849751748916523126735498953284617371598246564321879289467135",
    d: -12605,
  },
  {
    p: "405030620038100500672540301100086405000075109060014000806423000201607000700800046",
    s: "415739628938162574672548391127986435384275169569314782856423917241697853793851246",
    d: -12654,
  },
  {
    p: "016279050002084790890003021009000000600705100508000064765310000000097605901650003",
    s: "416279358352184796897563421129846537634725189578931264765318942283497615941652873",
    d: -12357,
  },
  {
    p: "010000289030080756000206134160059400092614300040720000084102060623805000700000000",
    s: "416537289239481756578296134167359428892614375345728691984172563623845917751963842",
    d: -13181,
  },
];
